import {collapseElement, expandElement, getNextSibling, updateQueryStringParam} from "../Utils/Utils.js";

const ACFBlockServiceProviders = (domEl) => {

	//
	// sm+ only
	const regionsSelector = domEl.querySelector('.regions-selector');
	const countriesList = domEl.querySelector('.countries-list');

	const handleRegionClick = (e) => {
		e.preventDefault();

		// Get the options selected and update the urlParams
		if(history.pushState) {

			// Update the urlParams
			const uri = updateQueryStringParam('region', e.currentTarget.dataset.slug);
			window.history.replaceState({path:uri},'',uri);
		}

		regionsSelector.querySelectorAll('.region.js-active').forEach(region => region.classList.remove('js-active'));
		e.currentTarget.classList.add('js-active');
		regionsSelector.setAttribute('data-active', e.currentTarget.dataset.slug);
		countriesList.setAttribute('data-active', e.currentTarget.dataset.slug);
	};

	regionsSelector.querySelectorAll('.region').forEach(region => region.addEventListener('click', handleRegionClick));



	//
	// xs2sm only
	const toggleRegion = (e) => {
		e.preventDefault();

		const btn = e.currentTarget;
		const countriesEl = getNextSibling(btn, '.countries');

		if(countriesEl.classList.contains('js-expanded')) {

			btn.classList.remove('js-expanded');
			collapseElement(countriesEl, () => {
				countriesEl.classList.remove('js-expanded');
			});
		}
		else {
			btn.classList.add('js-expanded');
			expandElement(countriesEl, () => {
				countriesEl.classList.add('js-expanded');
			});
		}

	}

	document.querySelectorAll('.toggle-region-btn').forEach(btn => btn.addEventListener('click', toggleRegion));
};

export default ACFBlockServiceProviders;